import React from "react";

const ChevronLeftIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({className, ...props}) => (
  <svg
    className={className}
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    focusable="false"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.9425 6.22402C21.4632 6.74472 21.4632 7.58894 20.9425 8.10964L12.552 16.5002L20.9425 24.8907C21.4632 25.4114 21.4632 26.2556 20.9425 26.7763C20.4218 27.297 19.5776 27.297 19.0569 26.7763L9.72353 17.443C9.20283 16.9223 9.20283 16.0781 9.72353 15.5574L19.0569 6.22402C19.5776 5.70332 20.4218 5.70332 20.9425 6.22402Z"
      fill="currentColor"
    />
  </svg>
);

export default ChevronLeftIcon;